module.exports = __webpack_public_path__ + "static/media/li-2.5fc22816.png";